import { useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import { AuthContext as AuthContextCareerist } from '../contexts/auth.careerist';

const IS_CAREERIST = process.env.REACT_APP_IS_CAREERIST === 'true';

export default function useAuth() {
  return useContext(IS_CAREERIST ? AuthContextCareerist : AuthContext);
}
